import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';

export default class PreLoginSessionCheck extends PreLoginPage{
	constructor(props) {
		super(props);
	}
	
	sessionCheck(){
		var me = this;
		var success = function(userObj){
			//me.setState({loggedIn:true});
		}

		var failure = function(error){
			//empty function for now
		}

		super.sessionCheck(success,failure);
	}

	render() {
		return this.showLoader();
	}
}


// WEBPACK FOOTER //
// ./src/prelogin/src/components/PreLoginSessionCheck.js